import React from "react";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import styled, { css } from "styled-components";

const SelectNumberInputWrapper = styled.div`
  display: block;
  font-family: "Roboto Mono";
  position: relative;

.buttons {
    background: transparent;
    position: absolute;
    right: 60px;
    top: 56px;
    width: 60px;
    display: flex;

    button{
      -ms-flex: 60px;
      -webkit-flex: 60px;
      background: transparent;
      border: none;
      border-left: 1px solid #2d2e30;
      color: #ff5000;
      flex: 60px;
      font-size: 32px;
      font-weight: 300;
      height: 60px;
      padding: 0 20px;
      width: 90px;
      cursor: pointer;

      &:focus, &:active {
        outline: none;

      }
  }

}

  label {
    font-family: "Roboto Mono",
    display: block;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 300;
    color: #7f7f7f;
    margin: 30px 0 10px;
  }

  input {
    background: black;
    border: 1px solid #2d2e30;
    height: 60px;
    font-size: 16px;
    line-height: 60px;
    color: white;
    display: block;
    font-size: 26px;
    font-weight: 300;
    font-weight: bold;
    text-transform: uppercase;
    width: 100%;
    padding: 0 20px;

    @media (max-width: 767.98px) {
      font-size: 20px;
    }

    &:active, &:focus {
      border-color: #ff5000;
      outline: none;
    }
  }
/*
  ${props => {
    if (props.summary) {
      return css`
        >
      `;
    }
  }}; */
  span {
    font-family: "Roboto Mono";
    color: #ff5000;
    font-size: 40px;
  }
`;

const SelectNumberInput = ({
  summary,
  displayType,
  defaultValue,
  value,
  name,
  onChange,
  selectData,
  title
}) => {
  const selectDataSorted = selectData
    .map(item => {
      return parseInt(item.list);
    })
    .sort((a, b) => a - b);

  const decrement = () => {
    let index = selectDataSorted.indexOf(value);
    const changed = selectDataSorted[index - 1];

    if (changed !== undefined) {
      onChange(name, changed);
    }

    if (index === -1) {
      onChange(name, selectDataSorted[0]);
    }
  };

  const increment = () => {
    let index = selectDataSorted.indexOf(value);
    const changed = selectDataSorted[1 + index];

    if (changed) {
      onChange(name, changed);
    }

    if (index === -1) {
      onChange(name, selectDataSorted[0]);
    }
  };

  return (
    <SelectNumberInputWrapper summary={summary}>
      <label>{title}</label>
      <NumberFormat
        allowNegative={true}
        defaultValue=""
        value={value}
        thousandSeparator=" "
        displayType={displayType}
        decimalScale={summary ? 0 : 2}
        decimalSeparator=","
        suffix={"%"}
        disabled
      />
      <div className="buttons">
        <button onClick={decrement}>-</button>
        <button onClick={increment}>+</button>
      </div>
    </SelectNumberInputWrapper>
  );
};

SelectNumberInput.defaultProps = {
  displayType: "input",
  defaultValue: "",
  name: "",
  onChange: () => {},
  title: ""
};

SelectNumberInput.propTypes = {
  displayType: PropTypes.string,
  selectData: PropTypes.array,
  name: PropTypes.string,
  onChange: PropTypes.func,
  title: PropTypes.string
};

export default SelectNumberInput;
